(() => {
  const init = (root) => {
    if (root.dataset.wearablesDirectoryReady === 'true') return;
    root.dataset.wearablesDirectoryReady = 'true';

    const filters = Array.from(root.querySelectorAll('[data-wearables-filter]'));
    const items = Array.from(root.querySelectorAll('[data-wearables-item]'));
    const heading = root.querySelector('[data-wearables-results-heading]');
    const status = root.querySelector('[data-wearables-results-status]');
    const searchForm = root.querySelector('[data-wearables-search-form]');
    const searchInput = root.querySelector('[data-wearables-search]');
    const clearButton = root.querySelector('[data-wearables-search-clear]');
    const noResults = root.querySelector('[data-wearables-no-results]');

    if (!filters.length || !items.length) return;

    let activeBrand = 'all';
    let activeLabel = 'All Wearable Skins';

    const normalize = (value) => String(value || '').trim().toLowerCase();

    const applyFilters = () => {
      const query = normalize(searchInput?.value);
      let visible = 0;

      items.forEach((item) => {
        const card = item.querySelector('[data-search]');
        const searchableText = normalize(`${card?.dataset.search || ''} ${item.dataset.wearablesBrand || ''}`);
        const matchesBrand = activeBrand === 'all' || item.dataset.wearablesBrand === activeBrand;
        const matchesSearch = !query || searchableText.includes(query);
        const show = matchesBrand && matchesSearch;

        item.hidden = !show;
        if (show) visible += 1;
      });

      filters.forEach((button) => {
        const active = button.dataset.wearablesFilter === activeBrand;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      if (heading) {
        heading.textContent = activeBrand === 'all' ? 'All Wearable Skins' : `${activeLabel} Wearable Skins`;
      }
      if (status) {
        const searchStatus = query ? ` matching “${searchInput.value.trim()}”` : '';
        status.textContent = `${visible} ${visible === 1 ? 'item' : 'items'}${searchStatus}, newest first`;
      }
      if (clearButton) clearButton.hidden = !query;
      if (noResults) noResults.hidden = visible !== 0;
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        activeBrand = button.dataset.wearablesFilter || 'all';
        activeLabel = button.dataset.label || 'All Wearable Skins';
        applyFilters();
      });
    });

    searchForm?.addEventListener('submit', (event) => event.preventDefault());
    searchInput?.addEventListener('input', applyFilters);
    clearButton?.addEventListener('click', () => {
      searchInput.value = '';
      applyFilters();
      searchInput.focus();
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-sw-wearables-directory]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
